import { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import classes from './FilterSalary.module.css';
import { useDebounce } from '../../../../../hooks/useDebounce';

export const FilterSalary = () => {
  const [t] = useTranslation('global');
  const [searchParams, setSearchParams] = useSearchParams();
  const [maxSalaryValue, setMaxSalaryValue] = useState<string>(
    searchParams.get('MaxSalary') ?? ''
  );
  const [error, setError] = useState<string>('');
  const debouncedValue = useDebounce<string>(maxSalaryValue, 1_500);

  useEffect(() => {
    const newParams = new URLSearchParams(searchParams);
    if (debouncedValue) {
      newParams.set('MaxSalary', debouncedValue);
    } else {
      newParams.delete('MaxSalary');
    }
    // Guard: only update URL when MaxSalary actually changed; without this,
    // setSearchParams triggers a new searchParams reference which re-fires this
    // effect indefinitely (stack overflow).
    if (newParams.get('MaxSalary') !== searchParams.get('MaxSalary')) {
      setSearchParams(newParams);
    }
  }, [debouncedValue, setSearchParams, searchParams]);

  const handleInputChange = (
    event: ChangeEvent<HTMLInputElement>,
    setInput: React.Dispatch<React.SetStateAction<string>>
  ) => {
    const inputValue: string = event.target.value;
    setInput(inputValue.replace(/[^0-9]/g, ''));
    setError('');
  };

  return (
    <div className={classes.FilterSalaryContainer}>
      <p className={classes.Title}>{t('Filters.salary')}</p>
      <div className={classes.InputsContainer}>
        <input
          type="text"
          placeholder="Salary"
          className={classes.FilterInput}
          value={maxSalaryValue}
          onChange={(e) => {
            handleInputChange(e, setMaxSalaryValue);
          }}
        />
      </div>
      {error && (
        <p className={classes.ErrorMessage} data-testid="error">
          {error}
        </p>
      )}
    </div>
  );
};
